export const FILE_LIST_DEFAULT_FLOATING_SHIFT = { right: 40, left: 40, bottom: 16, top: 90 } as const;
